import React, { useState } from 'react';
import { connect } from 'react-redux';
// import * as firebase from 'firebase/app';
import PropTypes from 'prop-types';
import ModalLoginForm from '../ModalLoginForm';
// import { auth, authError } from '../../../redux/actions/authActions';

function withAuthFirebase(WrappedComponent) {
  function HocAuth(props) {
    // const { history, dispatch } = props;
    const [error, setError] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => {
      setIsOpen(!isOpen);
    };

    // const onSubmitFireBase = async ({ username, password }) => {
    //   /* setError('');
    //   try {
    //     const res = await firebase.auth().signInWithEmailAndPassword(username, password);
    //     dispatch(auth({ name: res.user.email }));
    //     navigate('/app_dashboard');
    //     setIsOpen(false);
    //   } catch (e) {
    //     setError(e.message);
    //   } */
    // };

    // const onLoginGoogle = async () => {
    //   /* const provider = new firebase.auth.GoogleAuthProvider();
    //   try {
    //     const res = await firebase.auth().signInWithPopup(provider);
    //     localStorage.setItem('ynb', res.credential.accessToken);
    //     dispatch(auth({ name: res.user.displayName, avatar: res.user.photoURL }));
    //     navigate('/app_dashboard');
    //   } catch (e) {
    //     dispatch(authError(e.message));
    //   } */
    // };

    // const onLoginFacebook = async () => {
    //   /* const provider = new firebase.auth.FacebookAuthProvider();
    //   try {
    //     const res = await firebase.auth().signInWithPopup(provider);
    //     localStorage.setItem('ynb', res.credential.accessToken);
    //     dispatch(auth({ name: res.user.displayName, avatar: res.user.photoURL }));
    //     navigate('/app_dashboard');
    //   } catch (e) {
    //     dispatch(authError(e.message));
    //   } */
    // };

    const changeIsOpenModalFireBase = () => {
      setIsOpen(true);
      setError('');
    };

    return (
      <div className="account">
        <ModalLoginForm
          title="Sign in with Firebase"
          isOpen={isOpen}
          error={error}
          form="log_in_modal"
          // onSubmit={onSubmitFireBase}
          closeModal={closeModal}
          // onGoogleClick={onLoginGoogle}
          // onFacebookClick={onLoginFacebook}
        />
        <WrappedComponent {...props} changeIsOpenModalFireBase={changeIsOpenModalFireBase} />
      </div>
    );
  }

  HocAuth.propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  return connect()(HocAuth);
}

export default withAuthFirebase;
